import React from 'react';
export function FinalCTA() {
  return <section id="contact" className="relative bg-apex-green py-24 md:py-32 overflow-hidden" data-id="element-45">
      {/* Subtle Pattern Overlay */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-46" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-47">
        <div className="max-w-4xl mx-auto text-center" data-id="element-48">
          <h2 className="text-white font-extrabold text-4xl md:text-6xl tracking-tight mb-6" data-id="element-49">
            Your Next Listing Should Sell Itself.
          </h2>
          <p className="text-white/90 text-xl md:text-2xl font-medium mb-10 max-w-2xl mx-auto" data-id="element-50">
            Get a same-day quote and see why Phoenix realtors are switching to
            Apex.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 w-full sm:w-auto max-w-md mx-auto sm:max-w-none" data-id="element-51">
            <a href="#quote" className="bg-white hover:bg-gray-50 text-apex-charcoal text-center px-8 py-4 rounded-md font-bold text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 min-h-[48px] flex items-center justify-center" data-id="element-52">
              Request A Quote
            </a>
            <a href="tel:+15555555555" className="bg-transparent border-2 border-white hover:bg-white/10 text-white text-center px-8 py-4 rounded-md font-bold text-lg transition-all min-h-[48px] flex items-center justify-center" data-id="element-53">
              Call (555) 555-5555
            </a>
          </div>

          {/* A2P Compliance Note (Optional/Hidden by default unless form is used, but included per brief) */}
          <div className="mt-12 text-left max-w-2xl mx-auto bg-black/10 p-6 rounded-md backdrop-blur-sm hidden" data-id="element-54">
            <div className="flex items-start gap-3 mb-4" data-id="element-55">
              <input type="checkbox" id="a2p-trans" className="mt-1 w-4 h-4 rounded border-white/30 bg-transparent text-white focus:ring-white focus:ring-offset-apex-green" data-id="element-56" />
              <label htmlFor="a2p-trans" className="text-white/80 text-xs leading-tight" data-id="element-57">
                I agree to receive transactional messages (quote confirmations,
                appointment reminders) from Apex Curbside Appeal at the phone
                number provided. Message and data rates may apply. Reply STOP to
                opt out.
              </label>
            </div>
            <div className="flex items-start gap-3" data-id="element-58">
              <input type="checkbox" id="a2p-mktg" className="mt-1 w-4 h-4 rounded border-white/30 bg-transparent text-white focus:ring-white focus:ring-offset-apex-green" data-id="element-59" />
              <label htmlFor="a2p-mktg" className="text-white/80 text-xs leading-tight" data-id="element-60">
                I agree to receive marketing messages (promotions, updates) from
                Apex Curbside Appeal at the phone number provided. Message and
                data rates may apply. Reply STOP to opt out.
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>;
}